import { action, makeObservable, observable, runInAction } from 'mobx';

import { ZynTaskService } from '../services';

type StoreConstructor = Function & { [IS_STORE_TYPE]?: boolean };

const IS_STORE_TYPE = 'IS_STORE_TYPE';

const Store = (constructor: StoreConstructor) => {
  constructor[IS_STORE_TYPE] = true;
};

@Store
class FormStore {
  public constructor() {
    makeObservable(this);
  }

  public services = {
    apiService: new ZynTaskService()
  };

  @observable
  public loading: boolean = false;

  @observable
  public popup: boolean = false;

  @observable
  public errorOtp: boolean = false;

  @observable
  public popupType: string = 'otp';

  @observable
  public subscription: boolean = false;

  @observable
  public locale: string = 'ua';

  @observable
  public verified: boolean = true;

  // @observable
  // public isAgeGate: boolean = false;

  @observable
  public ageWarning: boolean = false;

  @observable
  public warning: boolean = false;

  @observable
  public warningMessage: string = '';

  @action.bound
  public setVerified(par) {
    this.verified = par;
  }

  @action.bound
  public setAgeWarning(par) {
    this.ageWarning = par;
  }

  // @action.bound
  // public setIsAgeGate(par) {
  //   this.isAgeGate = par;
  // }

  @action.bound
  public setWarning(par) {
    this.warning = par;
  }

  @action.bound
  public setWarningMessage(par) {
    this.warningMessage = par;
  }

  @action.bound
  public setLoading(par) {
    this.loading = par;
  }

  @action.bound
  public setPopupType(par) {
    this.popupType = par;
  }

  @action.bound
  public setPopup(par) {
    this.popup = par;
  }

  @action.bound
  public windowDataLayerPush = (payload: any) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };

  @action.bound
  public setErrorOtp(par) {
    this.errorOtp = par;
  }
  @action.bound
  public setSubscription(par) {
    this.subscription = par;
  }

  @action.bound
  sendPhone = async (
    params: any,
    phone: string,
    resetTimer: any,
    stopTimer: any
  ) => {
    try {
      this.setLoading(true);
      this.setPopup(true);
      const res: any = await this.services.apiService.sendZynTask(
        params,
        phone.replaceAll(' ', '').replaceAll('+', ''),
        'sendOtp_v2_zyn'
      );
      this.setLoading(false);
      this.setPopupType('otp');
      stopTimer();
      resetTimer();
    } catch (error) {
      this.setPopupType('error');
    } finally {
      this.setLoading(false);
    }
  };

  @action.bound
  sendOtp = async (
    otp: string,
    params: any,
    phone: string,
    subscription: any
  ) => {
    try {
      this.setLoading(true);
      const step = 'NotRegisteredValidateOTP_v2_zyn';
      this.setPopup(true);
      const res: any = await this.services.apiService.sendZynTask(
        params,
        phone.replaceAll(' ', '').replaceAll('+', ''),
        step,
        otp,
        subscription.toString()
      );
      const { message } = res.data.data;

      this.setLoading(false);

      if (message === 'wrong_otp') {
        this.setErrorOtp(true);
        this.windowDataLayerPush({ event: 'try_zyn_otp_form_error' });
      } else {
        this.setPopupType(message);
        switch (message) {
          case 'ok':
            this.windowDataLayerPush({ event: 'try_zyn_order_success' });
            break;
          case 'duplicate':
            this.windowDataLayerPush({ event: 'try_zyn_order_duplicate' });
            break;
          case 'error':
            this.windowDataLayerPush({ event: 'try_zyn_order_fail' });
            break;
          default:
            this.windowDataLayerPush({ event: 'try_zyn_order_fail' });
        }
      }
    } catch (error) {
      this.setPopupType('error');
    } finally {
      this.setLoading(false);
    }
  };

  @action.bound
  sendCall = async (params: any, phone: string) => {
    this.windowDataLayerPush({ event: 'try_zyn_click_call_me' });
    this.setLoading(true);
    const step = 'makeVoiceCall_v2_zyn';
    try {
      const res: any = await this.services.apiService.sendZynTask(
        params,
        phone.replaceAll(' ', '').replaceAll('+', ''),
        step
      );
      this.setSubscription(
        res.data.data.subscription ? res.data.data.subscription : false
      );
    } catch (error) {
      this.setPopupType('error');
    } finally {
      this.setLoading(false);
    }
  };
}

export { FormStore };
